import { createContext, useContext } from 'react'

export const HideDirtyStateContext = createContext<boolean>(false)
export const useHideDirtyState = (): boolean => useContext(HideDirtyStateContext)
